export const constants = {
    CLEAR_ROOT: "CLEAR_ROOT",
    UPDATE_VIEW: "UPDATE_VIEW",
    SET_LANG: "SET_LANG",
    SET_MAP_PROPERTIES: "SET_MAP_PROPERTIES",
    SET_SELECTED_PLACE: "SET_SELECTED_PLACE",
    UPDATE_SELECTED_PLACE: "UPDATE_SELECTED_PLACE",
    UPDATE_FORM_VALUE: "UPDATE_FORM_VALUE",
    SET_ERROR: "SET_ERROR"
};